import { AuthService } from "./AuthService";
import { ApiService } from "./ApiService";
import { SERVICE_URL } from "../evironment";
import { UiService } from "./UiService";
import { QueryParamsFactory } from "./QueryParamsFactory";
import { UsersService } from "./UsersService";
import { AnswersService } from "./AnswersService";
import { QuestionsService } from "./QuestionsService";
import { StartEndService } from "./StartEndService";
const queryParamsFactory = new QueryParamsFactory();
const uiService = new UiService();
const apiService = new ApiService(SERVICE_URL, uiService);
const authService = new AuthService(apiService);
const usersService = new UsersService(apiService, queryParamsFactory);
const answersService = new AnswersService(apiService, queryParamsFactory);
const questionsService = new QuestionsService(apiService, queryParamsFactory);
const startEndService = new StartEndService(apiService);
export { uiService, authService, usersService, answersService, questionsService, startEndService };
